import React from 'react';
import { Clear } from '@mui/icons-material';
import {
  Modal,
  Box,
  Paper,
  Typography,
  IconButton,
  Backdrop,
  Fade,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import { useStyles } from './useStyles';
import { Call } from './Call';
import { Footer } from './Footer';
import { CustomButton } from '@buttons/CustomButton';
import phoneLogo from '@assets/images/Group 6867.svg';
import envelop from '@assets/images/Envelop.svg';
import backarrow from '@assets/images/BackArrow.svg';
import { ZustandContext } from '@store/modalStore';
import { ModalHelp } from './ModalHelp';

type ModalHomeProps = {
  onClose: () => void;
};

export const ModalContact: React.FC<ModalHomeProps> = ({ onClose }) => {
  const classes = useStyles();
  const { breakpoints, palette } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('lg'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const { show, hide } = React.useContext(ZustandContext);

  const handleClickSurfly = () => {
  };

  return (
    <Modal
      open
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in>
        <Paper className={classes.root} style={{ height: '370px' }}>
          <Box
            padding={2}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
              alignItems={'center'}
              textAlign="center"
              position={'relative'}
            >
              <Typography
                variant={'h6'}
                fontWeight={'bold'}
                marginLeft="14px"
                paddingTop="25px"
                marginBottom="20px"
              >
                ¿No sabes qué onda?
              </Typography>
              <Box position={'absolute'} top={-5} right={-50}>
                <IconButton onClick={onClose}>
                  <Clear />
                </IconButton>
              </Box>
            </Box>
            <Typography
              fontWeight={700}
              textAlign={'center'}
              fontSize={16}
              width={253}
              marginBottom={3}
            >
              ¡Tú tranqui! En un momentito te contactaremos por acá para
              ayudarte.
            </Typography>
            <Typography marginBottom={3}>
              ¡No cierres la ventana ni tu navegador!{' '}
            </Typography>
            <CustomButton
              text={'¡SALE VALE!'}
              onClick={handleClickSurfly}
              color={'primary'}
              variant={'contained'}
              style={{ height: 56, width: '100%', textTransform: 'none' }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <CustomButton
              text="Mejor por otro medio de contacto"
              onClick={() => show(ModalHelp, { onClose: hide })}
              variant={'text'}
              style={{
                color: palette.primary.main,
                textTransform: 'none',
              }}
            />
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
